export const NEAR_BOTTOM_THRESHOLD = 50;
